import React from "react";
import ReactDOM from "react-dom/client";
import { Schedule } from "./Schedule";

import "../styles.css";

const root = ReactDOM.createRoot(
  document.getElementById("redcoach-megabus-schedule")
);

const elementRoot = document.getElementById("redcoach-megabus-schedule");

const type = elementRoot.getAttribute("data-type");

root.render(
  <React.StrictMode>
    <Schedule type={type} />
  </React.StrictMode>
);
